import * as React from "react";
import { Table} from "antd";
import { connect } from "react-redux";
//import moment from "moment";

interface IWechatlistProps {
  id:any;
  wechatlist:any;
}

// 修改
class Wechatlist extends React.Component<IWechatlistProps, any> {
  state = {
     list:[]
  };
  constructor(props: IWechatlistProps) {
    super(props);
  }

  componentDidMount() {
    this.wechatlist();     
  }

  wechatlist = () =>{
    const param: any = {
      id: this.props.id
    }; 
    this.props.wechatlist({
      ...param,
      callback: (data) => {
        this.setState({
           list: data
        });
      }
     });    
  }

  render() {
    const dataSource = this.state.list;
    
    const columns = [{
      title: '发送时间',
      dataIndex: 'send_time',
      key:'send_time',
      className:'th',
      width: 300,
    }, {
      title: '推送内容',
      dataIndex: 'type',
      key:'type',
      className:'th',

    }, {
      title: '操作人',
      dataIndex: 'do_user',
      key:'do_user',
      className:'th',
      render: (text, row, index) => {
        return (
          <React.Fragment>
               {row.send_statu == 1 ? '发送成功' : ''} 
          </React.Fragment>
        );
      }
    }];

    
    return (
      <React.Fragment>
           <div className="from-email"> 
                   <Table bordered={true} expandIconAsCell={false} expandIconColumnIndex={-1} pagination={false} dataSource={dataSource} columns={columns} />
           </div>
      </React.Fragment>
    );
  }
}

const mapState = state => ({
  id: state.orderDetails.id,
});

const mapDispatch = dispatch => {
  return {
    wechatlist: dispatch.orderDetails.wechatlist
  };
};


export default connect(
  mapState ,
  mapDispatch
)(Wechatlist);
